import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3208ad88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "car-id" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center flex-col bg-white border px-6 py-4"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-sm mt-2" }, "Загрузка данных автомобиля...", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 text-sm" }, " При получении данных автомобиля произошла ошибка ", -1))
const _hoisted_11 = { class: "grid grid-cols-3 gap-3 bg-white border px-6 py-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Компания", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Гос. номер", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Тип", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Модель", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Кубатура", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Грузоподъемность", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Код 1С", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Номер заявки Jira", -1))
const _hoisted_20 = {
  key: 0,
  class: "bg-white border px-6 py-4 mt-6"
}
const _hoisted_21 = { class: "text-lg font-semibold" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 1,
  class: "mt-3 text-gray-400 text-sm"
}
const _hoisted_25 = {
  key: 1,
  class: "bg-white border px-6 py-4 mt-6"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Загрузка тех. паспорта", -1))
const _hoisted_27 = { class: "flex items-center justify-end mt-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_history = _resolveComponent("history")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_page_title, {
          title: 
                        _ctx.state.car
                            ? `Автомобиль (${_ctx.state.car.model}, ${_ctx.state.car.number})`
                            : 'Автомобиль'
                    
        }, null, 8, ["title"]),
        (Boolean(_ctx.state.car))
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: _normalizeClass(["small ml-3", {
                        yellow: _ctx.isCarOnCheck,
                        green: _ctx.isCarActive,
                        red: _ctx.isCarArchive || _ctx.isCarReject,
                    }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.car.status.name), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isRenderRejectStatusButton)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              loading: _ctx.state.is_status_change_loading,
              class: "red small text mr-3",
              onClick: _ctx.setRejectStatus
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" Отказ ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isRenderActiveStatusButton)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              loading: _ctx.state.is_status_change_loading,
              class: "green text small mr-3",
              onClick: _ctx.setActiveStatus
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Активировать ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isRenderArchiveStatusButton)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 2,
              loading: _ctx.state.is_status_change_loading,
              class: "red text small mr-3",
              onClick: _ctx.setArchiveStatus
            }, {
              default: _withCtx(() => [
                _createTextVNode(" В архив ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_the_button, {
          class: "second small text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/couriers/cars')))
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" Назад ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.state.is_loading || _ctx.state.is_failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_9
                ], 64))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_10,
                    _createVNode(_component_the_button, {
                      class: "primary small text mt-3",
                      onClick: _ctx.loadCar
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перезагрузить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _hoisted_12,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.car.company ? _ctx.state.car.company.name : '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.car.number), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_14,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.car.vehicle_type_name), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.car.model), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_16,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.car.cubature), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_17,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.car.ftl_car_type_name), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_18,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.car.code_1C), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.car.jira_ticket || '-'), 1)
              ])
            ]),
            (Boolean(_ctx.state.car))
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("p", _hoisted_21, " Фото тех. паспорта (" + _toDisplayString(_ctx.state.car.technical_passports.length) + ") ", 1),
                  (Boolean(_ctx.state.car.technical_passports.length))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.car.technical_passports, (photo) => {
                          return (_openBlock(), _createElementBlock("img", {
                            key: photo.url,
                            class: "mt-2 object-cover",
                            style: {"max-width":"800px","max-height":"400px"},
                            src: photo.url
                          }, null, 8, _hoisted_23))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, " Фото тех. паспорта не загружены "))
                ]))
              : _createCommentVNode("", true),
            (Boolean(_ctx.state.car) && _ctx.isCanUploadDocuments)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_component_file_reader, {
                    class: "mt-3",
                    placeholder: "Выберите изображение",
                    accept: "image/*",
                    value: _ctx.upload_state.technical_passport,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.upload_state.technical_passport) = $event)),
                    multiple: "",
                    disabled: _ctx.upload_state.is_technical_passport_loading,
                    "is-invalid": _ctx.upload_state$.technical_passport.$error,
                    "validation-errors": _ctx.upload_state$.technical_passport.$errors
                  }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_the_button, {
                      class: "primary small text",
                      loading: _ctx.upload_state.is_technical_passport_loading,
                      onClick: _ctx.uploadTechnicalPassport
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28,
                        _createTextVNode(" Загрузить ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isHistory)
              ? (_openBlock(), _createBlock(_component_history, {
                  key: 2,
                  class: "mt-6",
                  identifier: _ctx.state.car.number,
                  type: 3
                }, null, 8, ["identifier"]))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ]))
}